import { IAppState } from '../../redux';

export function selectIsAutoProlongChecked(state: IAppState): boolean {
  const {
    checkoutInfo: { autoProlongInfo },
  } = state;

  return autoProlongInfo.isChecked;
}
